document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('splide1')) {
        new Splide('#splide1', {
            perPage: 3,
            rewind: true,
            gap: 40,
            pagination: false,
            perMove: 1,
            breakpoints: {
                992: {
                    fixedWidth: 240,
                    perPage: 2,
                    gap: 40,
                    updateOnMove: true,
                },
                767: {
                    fixedWidth: 300,
                    perPage: 1,
                    gap: 40,
                    updateOnMove: true,
                },
            },
        }).mount();
    }

    if (document.getElementById('splide2')) {
        new Splide('#splide2', {
            perPage: 3,
            rewind: true,
            gap: 40,
            pagination: false,
            perMove: 1,
            breakpoints: {
                992: {
                    fixedWidth: 240,
                    perPage: 2,
                    gap: 40,
                    updateOnMove: true,
                },
                767: {
                    fixedWidth: 300,
                    perPage: 1,
                    gap: 40,
                    updateOnMove: true,
                },
            },
        }).mount();
    }
});
